<template>
  <div class="flex flex-col items-start md:flex-col-reverse [&>*]:w-full">
    <slot />
  </div>
</template>
